"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var https_1 = __importDefault(require("https"));
exports.get = function (query) {
    return new Promise(function (resolve, reject) {
        var req = https_1.default.get({
            headers: { 'Content-Type': 'application/json' },
            host: 'api.datamuse.com',
            path: "/words?" + query
        }, function (res) {
            res.setEncoding('utf-8');
            if (!res.statusCode || res.statusCode < 200 || res.statusCode >= 300) {
                return reject(new Error('statusCode=' + res.statusCode));
            }
            var rawBody = '';
            var body = {};
            res.on('data', function (chunk) { return (rawBody = chunk); });
            res.on('end', function () {
                try {
                    body = JSON.parse(rawBody);
                }
                catch (e) {
                    reject(e);
                }
                resolve(body);
            });
        });
        req.on('error', function (err) { return reject(err); });
        req.end();
    });
};
//# sourceMappingURL=httpGet.js.map